import React, { useState } from "react";
import LoginModal from "./LoginModal";
import RegisterModal from "./RegisterModal";
import {
  HeaderWrapper,
  LeftBar,
  RightBar,
  Logo,
  LoginButton,
  Button,
  DropdownItem,
  DropdownMenu,
  AvatarWrapper,
  Avatar,
} from "./style";
import { ToastContainer } from "react-toastify";
import ProfileModal from "./Profile";
import ChangePassword from "./ChangePassword";
import logoImg from "../assets/logo/Logo.png";

const Header = ({ setLoginUser }) => {
  const user = localStorage.getItem("user");
  const userProfile = user ? JSON.parse(user) : null;
  const [showMenu, setShowMenu] = useState(false);
  const [isLoginOpen, setLoginOpen] = useState(false);
  const [isRegisterOpen, setRegisterOpen] = useState(false);
  const [isProfileOpen, setProfileOpen] = useState(false);
  const [isChanPassOpen, setChanPassOpen] = useState(false);

  const handleLoginOpen = () => setLoginOpen(true);
  const handleRegisterOpen = () => setRegisterOpen(true);
  const handleLoginClose = () => setLoginOpen(false);
  const handleRegisterClose = () => setRegisterOpen(false);

  const logout = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_URL}/logout`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${userProfile.token}`,
          "Content-Type": "application/json",
        },
      });

      if (response.ok) {
        localStorage.clear();
        window.location.reload();
      } else {
        console.error("Logout failed");
      }
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  const handleProfileClose = () => {
    setProfileOpen(false);
  };

  const handleChangePassClose = () => {
    setChanPassOpen(false);
  };

  const updateUserProfile = (updatedProfile) => {
    localStorage.setItem("user", JSON.stringify(updatedProfile));
    setLoginUser(updatedProfile);
  };

  const getInitials = (name) => {
    if (!name) return "";
    const names = name.split(" ");
    const initials =
      names[0].charAt(0).toUpperCase() +
      (names[1] ? names[1].charAt(0).toUpperCase() : "");
    return initials;
  };

  const initials = userProfile ? getInitials(userProfile.user.name) : "";
  return (
    <>
      <ToastContainer />
      <HeaderWrapper>
        <LeftBar>
          <Logo>
            <img width={200} src={logoImg} alt="logo" />
          </Logo>
        </LeftBar>
        <RightBar>
          {user ? (
            <>
              <AvatarWrapper
                onMouseEnter={() => setShowMenu(true)}
                onMouseLeave={() => setShowMenu(false)}
              >
                <Avatar>
                  <p>{initials}</p>
                </Avatar>
                {showMenu && (
                  <DropdownMenu>
                    <DropdownItem onClick={() => setProfileOpen(true)}>
                      Profile
                    </DropdownItem>
                    <DropdownItem onClick={() => setChanPassOpen(true)}>
                      Change Password
                    </DropdownItem>
                  </DropdownMenu>
                )}
              </AvatarWrapper>
              <Button onClick={() => logout()}>Logout</Button>
            </>
          ) : (
            <>
              <LoginButton onClick={handleLoginOpen}>Login</LoginButton>
              <Button onClick={handleRegisterOpen}>Register</Button>
            </>
          )}
        </RightBar>
        <LoginModal
          isOpen={isLoginOpen}
          onClose={handleLoginClose}
          setLoginUser={setLoginUser}
        />
        <RegisterModal isOpen={isRegisterOpen} onClose={handleRegisterClose} />
        {userProfile && (
          <ProfileModal
            isOpen={isProfileOpen}
            onClose={handleProfileClose}
            setUserProfile={updateUserProfile}
            userProfile={userProfile}
          />
        )}
        <ChangePassword
          isOpen={isChanPassOpen}
          onClose={handleChangePassClose}
          userProfile={userProfile}
        />
        {/* <ForgotModal isOpen={isChanPassOpen} onClose={handleChangePassClose} /> */}
      </HeaderWrapper>
    </>
  );
};

export default Header;
